export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14954.b3b116b0.jpg";